import { render, staticRenderFns } from "./BaseSkeletonLoader.vue?vue&type=template&id=74abfda6&scoped=true&"
import script from "./BaseSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./BaseSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseSkeletonLoader.vue?vue&type=style&index=0&id=74abfda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74abfda6",
  null
  
)

export default component.exports